import { supabase } from '../supabaseClient';

/**
 * 上傳圖片到 Supabase Storage
 * @param {File} file - 圖片檔案
 * @param {string} departmentId - 部門 ID（用於組織路徑）
 * @returns {Promise<{success: boolean, url?: string, error?: string}>}
 */
export async function uploadMarkdownImage(file, departmentId) {
  try {
    const bucketName = 'item-images'; // 任務圖片專用 bucket
    
    // 生成唯一檔名
    const timestamp = Date.now();
    const randomString = Math.random().toString(36).substring(2, 8);
    const ext = file.name.split('.').pop();
    const fileName = `${timestamp}_${randomString}.${ext}`;
    
    // 路徑：department-id/filename（bucket 下的路徑）
    const filePath = `${departmentId || 'default'}/${fileName}`;
    
    // 上傳到 Supabase Storage
    const { data, error } = await supabase.storage
      .from(bucketName)
      .upload(filePath, file, {
        cacheControl: '3600',
        upsert: false,
      });
    
    if (error) {
      throw error;
    }
    
    // 取得公開 URL
    const { data: { publicUrl } } = supabase.storage
      .from(bucketName)
      .getPublicUrl(filePath);
    
    return {
      success: true,
      url: publicUrl,
    };
  } catch (error) {
    console.error('Error uploading image:', error);
    return {
      success: false,
      error: error.message || '上傳失敗',
    };
  }
}

/**
 * 刪除 Markdown 圖片
 * @param {string} url - 圖片 URL
 */
export async function deleteMarkdownImage(url) {
  try {
    const bucketName = 'item-images';
    
    // 從 URL 解析出檔案路徑
    const urlObj = new URL(url);
    const pathMatch = urlObj.pathname.match(/\/storage\/v1\/object\/public\/item-images\/(.+)/);
    
    if (!pathMatch) {
      throw new Error('Invalid image URL');
    }
    
    const filePath = pathMatch[1];
    
    const { error } = await supabase.storage
      .from(bucketName)
      .remove([filePath]);
    
    if (error) throw error;
    
    return { success: true };
  } catch (error) {
    console.error('Error deleting image:', error);
    return { success: false, error: error.message };
  }
}
